import {Input, Form, Modal, Col, Row, InputNumber, Card, Divider, Typography, message} from "antd";
import {useFormik} from "formik";

import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import * as yup from "yup";
import {useStore} from "../../../../hooks/useStore";
import moment from "moment";

const {Title, Text} = Typography;

const ShiftScoreObjectionModal = ({
    shiftScore,
    visibility,
    onCancel,
    closeModal,
    objectionType
}) => {
    const {t} = useTranslation([
        "shiftScore",
        "courierStatuses",
        "courierStatusUpdateModal",
        "changeStatusList"
    ]);
    const stores = useStore();
    const [loading, setLoading] = useState();
    const isCustomer = stores.meStore.checkRole("isNonApiIntegratedCustomer");
    const {
        _id = "",
        reportDate = "",
        fullname = "",
        tckn = "",
        cellPhone = "",
        companyName = "",
        companyCode = "",
        subCompanyName = "",
        subCompanyCode = "",
        shiftStartTime = "",
        shiftEndTime = "",
        startTime = "",
        endTime = "",
        workTimeMinute = "",
        busyTimeMinute = "",
        packageCount = ""
    } = shiftScore || {};

    const formik = useFormik({
        initialValues: {
            text: "",
            shiftReportId: _id,
            workTimeMinute: workTimeMinute ? Number(workTimeMinute) : 0,
            packageCount: packageCount ? Number(packageCount) : 0
        },
        validationSchema: yup.object().shape({
            text: yup.string().required(t("validation.required", {ns: "common"})),
            workTimeMinute: yup
                .number()
                .required(t("validation.required", {ns: "common"}))
                .min(0, "Negatif değer girilemez")
                .typeError("Geçerli bir sayı giriniz"),
            packageCount: yup
                .number()
                .required(t("validation.required", {ns: "common"}))
                .min(0, "Negatif değer girilemez")
                .typeError("Geçerli bir sayı giriniz")
        }),
        onSubmit: async values => {
            if (values.workTimeMinute === workTimeMinute && values.packageCount === packageCount) {
                message.error(
                    t("objectionDetail.revisionModal.errors.atLeastOneDifferent", {
                        ns: "objectionDetail"
                    })
                );
                return;
            }

            setLoading(true);
            await stores.shiftStore.createShiftScoreObjection(values);
            await resetForm();

            setLoading(false);
            closeModal();
        },
        enableReinitialize: true
    });

    const {values, errors, touched, handleChange, handleSubmit, resetForm, setFieldValue} = formik;

    const labels = {
        updateModal: {
            title: t("shiftScore.createObjectionModal.updateTitle", {ns: "shiftScore"}),
            okText: t("shiftScore.createObjectionModal.updateTitle", {ns: "shiftScore"}),
            workingTime: t("shiftScore.createObjectionModal.updateExpectedWorkTime", {
                ns: "shiftScore"
            }),
            packageCount: t("shiftScore.createObjectionModal.updatePackageCount", {
                ns: "shiftScore"
            }),
            objectionDescription: t("shiftScore.createObjectionModal.updateDescription", {
                ns: "shiftScore"
            }),
            formTitle: "Güncelleme Bilgileri"
        },
        objectionModal: {
            title: t("shiftScore.createObjectionModal.title", {ns: "shiftScore"}),
            okText: t("shiftScore.createObjectionModal.title", {ns: "shiftScore"}),
            workingTime: t("fields.expectedWorkTime", {ns: "common"}),
            packageCount: t("fields.expectedPackageCount", {ns: "common"}),
            objectionDescription: t("fields.objectionDescription", {ns: "common"}),
            formTitle: "İtiraz Bilgileri"
        }
    };

    return (
        <Modal
            title={
                <span style={{color: isCustomer ? "white" : "inherit"}}>
                    {labels[objectionType].title}
                </span>
            }
            visible={visibility}
            onCancel={onCancel}
            confirmLoading={loading}
            width={isCustomer ? "90vw" : "90vw"}
            style={{maxWidth: isCustomer ? 800 : 630}}
            okText={labels[objectionType].okText}
            onOk={handleSubmit}
            cancelText={t("modal.cancelButton2", {ns: "common"})}
            data-testid="createShiftReportObjection"
            className={isCustomer ? "shift-score-objection-modal customer-layout" : ""}
        >
            {isCustomer ? (
                // Customer için güncel layout
                <div style={{padding: "16px 0"}}>
                    {/* Bilgi Kartları */}
                    <Row gutter={[16, 16]} style={{marginBottom: "24px"}}>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Card
                                title={
                                    <Title level={5} style={{margin: 0}}>
                                        {t("fields.courier", {ns: "common"})} Bilgileri
                                    </Title>
                                }
                                size="small"
                                style={{boxShadow: "0 2px 8px rgba(0,0,0,0.1)"}}
                            >
                                <div style={{display: "flex", flexDirection: "column", gap: "8px"}}>
                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                        <Text strong>{t("fields.date", {ns: "common"})}:</Text>
                                        <Text>
                                            {reportDate
                                                ? moment(reportDate).format("DD.MM.YYYY")
                                                : "-"}
                                        </Text>
                                    </div>
                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                        <Text strong>{t("fields.courier", {ns: "common"})}:</Text>
                                        <Text>{fullname}</Text>
                                    </div>
                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                        <Text strong>
                                            {t("fields.courierIdNo", {ns: "common"})}:
                                        </Text>
                                        <Text>{tckn}</Text>
                                    </div>
                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                        <Text strong>
                                            {t("fields.courierPhone", {ns: "common"})}:
                                        </Text>
                                        <Text>{cellPhone}</Text>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Card
                                title={
                                    <Title level={5} style={{margin: 0}}>
                                        {t("fields.company", {ns: "common"})} Bilgileri
                                    </Title>
                                }
                                size="small"
                                style={{boxShadow: "0 2px 8px rgba(0,0,0,0.1)"}}
                            >
                                <div style={{display: "flex", flexDirection: "column", gap: "8px"}}>
                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                        <Text strong>{t("fields.company", {ns: "common"})}:</Text>
                                        <Text>{companyName}</Text>
                                    </div>
                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                        <Text strong>
                                            {t("fields.companyCode", {ns: "common"})}:
                                        </Text>
                                        <Text>{companyCode}</Text>
                                    </div>
                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                        <Text strong>
                                            {t("fields.subcompany", {ns: "common"})}:
                                        </Text>
                                        <Text>{subCompanyName}</Text>
                                    </div>
                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                        <Text strong>
                                            {t("fields.subCompanyCode", {ns: "common"})}:
                                        </Text>
                                        <Text>{subCompanyCode}</Text>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Row>

                    {/* Vardiya Bilgileri */}
                    <Card
                        title={
                            <Title level={5} style={{margin: 0}}>
                                Vardiya Detayları
                            </Title>
                        }
                        size="small"
                        style={{marginBottom: "24px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)"}}
                    >
                        <Row gutter={[16, 8]}>
                            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        border: "1px solid #e8e8e8",
                                        padding: "8px 12px",
                                        borderRadius: "4px",
                                        height: "40px",
                                        alignItems: "center"
                                    }}
                                >
                                    <Text strong style={{fontSize: "12px", minWidth: "80px"}}>
                                        {t("shiftScore.shiftStartTime", {ns: "shiftScore"})}:
                                    </Text>
                                    <Text style={{fontSize: "12px", textAlign: "right", flex: 1}}>
                                        {shiftStartTime}
                                    </Text>
                                </div>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        border: "1px solid #e8e8e8",
                                        padding: "8px 12px",
                                        borderRadius: "4px",
                                        height: "40px",
                                        alignItems: "center"
                                    }}
                                >
                                    <Text strong style={{fontSize: "12px", minWidth: "80px"}}>
                                        {t("shiftScore.shiftEndTime", {ns: "shiftScore"})}:
                                    </Text>
                                    <Text style={{fontSize: "12px", textAlign: "right", flex: 1}}>
                                        {shiftEndTime}
                                    </Text>
                                </div>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        border: "1px solid #e8e8e8",
                                        padding: "8px 12px",
                                        borderRadius: "4px",
                                        height: "40px",
                                        alignItems: "center"
                                    }}
                                >
                                    <Text strong style={{fontSize: "12px", minWidth: "80px"}}>
                                        {t("shiftScore.packageCount", {ns: "shiftScore"})}:
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: "12px",
                                            textAlign: "right",
                                            flex: 1,
                                            fontWeight: "bold"
                                        }}
                                    >
                                        {packageCount}
                                    </Text>
                                </div>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        border: "1px solid #e8e8e8",
                                        padding: "8px 12px",
                                        borderRadius: "4px",
                                        height: "40px",
                                        alignItems: "center"
                                    }}
                                >
                                    <Text strong style={{fontSize: "12px", minWidth: "80px"}}>
                                        {t("shiftScore.startTime", {ns: "shiftScore"})}:
                                    </Text>
                                    <Text style={{fontSize: "12px", textAlign: "right", flex: 1}}>
                                        {startTime || "-"}
                                    </Text>
                                </div>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        border: "1px solid #e8e8e8",
                                        padding: "8px 12px",
                                        borderRadius: "4px",
                                        height: "40px",
                                        alignItems: "center"
                                    }}
                                >
                                    <Text strong style={{fontSize: "12px", minWidth: "80px"}}>
                                        {t("shiftScore.endTime", {ns: "shiftScore"})}:
                                    </Text>
                                    <Text style={{fontSize: "12px", textAlign: "right", flex: 1}}>
                                        {endTime || "-"}
                                    </Text>
                                </div>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        border: "1px solid #e8e8e8",
                                        padding: "8px 12px",
                                        borderRadius: "4px",
                                        height: "40px",
                                        alignItems: "center"
                                    }}
                                >
                                    <Text strong style={{fontSize: "12px", minWidth: "80px"}}>
                                        {t("shiftScore.workTime", {ns: "shiftScore"})} (
                                        {t("units.minute.short", {ns: "common"})}):
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: "12px",
                                            textAlign: "right",
                                            flex: 1,
                                            fontWeight: "bold"
                                        }}
                                    >
                                        {workTimeMinute}
                                    </Text>
                                </div>
                            </Col>
                            {stores.meStore.checkRole("notVisibleForCompanyUser") && (
                                <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            border: "1px solid #e8e8e8",
                                            padding: "8px 12px",
                                            borderRadius: "4px",
                                            height: "40px",
                                            alignItems: "center"
                                        }}
                                    >
                                        <Text strong style={{fontSize: "12px", minWidth: "80px"}}>
                                            {t("shiftScore.busyTimeMinute", {ns: "shiftScore"})} (
                                            {t("units.minute.short", {ns: "common"})}):
                                        </Text>
                                        <Text
                                            style={{
                                                fontSize: "12px",
                                                textAlign: "right",
                                                flex: 1,
                                                fontWeight: "bold"
                                            }}
                                        >
                                            {busyTimeMinute}
                                        </Text>
                                    </div>
                                </Col>
                            )}
                        </Row>
                    </Card>

                    <Divider style={{margin: "16px 0"}} />

                    {/* Form Alanları */}
                    <Card
                        title={
                            <Title level={5} style={{margin: 0}}>
                                {labels[objectionType].formTitle}
                            </Title>
                        }
                        size="small"
                        style={{boxShadow: "0 2px 8px rgba(0,0,0,0.1)"}}
                    >
                        <Form autoComplete="off" layout="vertical">
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Form.Item
                                        label={
                                            <Text strong>{labels[objectionType].workingTime}</Text>
                                        }
                                        validateStatus={
                                            errors.workTimeMinute && touched.workTimeMinute
                                                ? "error"
                                                : "success"
                                        }
                                        help={
                                            errors.workTimeMinute && touched.workTimeMinute
                                                ? errors.workTimeMinute
                                                : null
                                        }
                                    >
                                        <InputNumber
                                            style={{width: "100%"}}
                                            name="workTimeMinute"
                                            value={values.workTimeMinute}
                                            onChange={value => {
                                                setFieldValue(`workTimeMinute`, value);
                                            }}
                                            data-testid="workTimeMinute"
                                            placeholder="Beklenen çalışma süresi"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Form.Item
                                        label={
                                            <Text strong>{labels[objectionType].packageCount}</Text>
                                        }
                                        validateStatus={
                                            errors.packageCount && touched.packageCount
                                                ? "error"
                                                : "success"
                                        }
                                        help={
                                            errors.packageCount && touched.packageCount
                                                ? errors.packageCount
                                                : null
                                        }
                                    >
                                        <InputNumber
                                            style={{width: "100%"}}
                                            name="packageCount"
                                            value={values.packageCount}
                                            onChange={value => {
                                                setFieldValue(`packageCount`, value);
                                            }}
                                            data-testid="packageCount"
                                            placeholder="Beklenen paket sayısı"
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item
                                label={
                                    <Text strong>{labels[objectionType].objectionDescription}</Text>
                                }
                                validateStatus={errors.text && touched.text ? "error" : "success"}
                                help={errors.text && touched.text ? errors.text : null}
                            >
                                <Input.TextArea
                                    rows={4}
                                    name="text"
                                    value={values.text}
                                    onChange={handleChange}
                                    data-testid="text"
                                    placeholder="Açıklamanızı buraya yazın..."
                                    style={{resize: "vertical"}}
                                />
                            </Form.Item>
                        </Form>
                    </Card>
                </div>
            ) : (
                // Diğer roller için orijinal layout
                <Row justify="space-between">
                    <Col>
                        <p>
                            <b>{t("fields.date", {ns: "common"})}</b> : {reportDate}
                        </p>
                        <p>
                            <b>{t("fields.courier", {ns: "common"})}</b> : {fullname}
                        </p>
                        <p>
                            <b>{t("fields.courierIdNo", {ns: "common"})}</b> : {tckn}
                        </p>
                        <p>
                            <b>{t("fields.courierPhone", {ns: "common"})}</b> : {cellPhone}
                        </p>
                        <p>
                            <b>{t("fields.company", {ns: "common"})}</b> : {companyName}
                        </p>
                        <p>
                            <b>{t("fields.companyCode", {ns: "common"})}</b> : {companyCode}
                        </p>
                        <p>
                            <b>{t("fields.subcompany", {ns: "common"})}</b> : {subCompanyName}
                        </p>
                        <p>
                            <b>{t("fields.subCompanyCode", {ns: "common"})}</b> : {subCompanyCode}
                        </p>
                    </Col>
                    <Col>
                        <p>
                            <b>{t("shiftScore.shiftStartTime", {ns: "shiftScore"})}</b> :{" "}
                            {shiftStartTime}
                        </p>
                        <p>
                            <b>{t("shiftScore.shiftEndTime", {ns: "shiftScore"})}</b> :{" "}
                            {shiftEndTime}
                        </p>
                        <p>
                            <b>{t("shiftScore.startTime", {ns: "shiftScore"})}</b> : {startTime}
                        </p>

                        <p>
                            <b>{t("shiftScore.endTime", {ns: "shiftScore"})}</b> : {endTime}
                        </p>
                        <p>
                            <b>
                                {t("shiftScore.workTime", {ns: "shiftScore"})} - (
                                {t("units.minute.short", {ns: "common"})})
                            </b>{" "}
                            : {workTimeMinute}
                        </p>
                        {stores.meStore.checkRole("notVisibleForCompanyUser") && (
                            <>
                                <p>
                                    <b>
                                        {t("shiftScore.busyTimeMinute", {ns: "shiftScore"})} - (
                                        {t("units.minute.short", {ns: "common"})})
                                    </b>{" "}
                                    : {busyTimeMinute}
                                </p>
                            </>
                        )}
                        <p>
                            <b>{t("shiftScore.packageCount", {ns: "shiftScore"})}</b> :{" "}
                            {packageCount}
                        </p>
                    </Col>

                    <Col>
                        <Form autoComplete="off" labelCol={{span: 24}} wrapperCol={{span: 24}}>
                            <Form.Item
                                colon={false}
                                label={`${labels[objectionType].workingTime} :`}
                                labelAlign="left"
                                validateStatus={
                                    errors.workTimeMinute && touched.workTimeMinute
                                        ? "error"
                                        : "success"
                                }
                                help={
                                    errors.workTimeMinute && touched.workTimeMinute
                                        ? errors.workTimeMinute
                                        : null
                                }
                            >
                                <InputNumber
                                    cols={120}
                                    rows={4}
                                    name="workTimeMinute"
                                    value={values.workTimeMinute}
                                    onChange={value => {
                                        setFieldValue(`workTimeMinute`, value);
                                    }}
                                    data-testid="workTimeMinute"
                                />
                            </Form.Item>
                            <Form.Item
                                colon={false}
                                label={`${labels[objectionType].packageCount}:`}
                                labelAlign="left"
                                validateStatus={
                                    errors.packageCount && touched.packageCount
                                        ? "error"
                                        : "success"
                                }
                                help={
                                    errors.packageCount && touched.packageCount
                                        ? errors.packageCount
                                        : null
                                }
                            >
                                <InputNumber
                                    name="packageCount"
                                    value={values.packageCount}
                                    onChange={value => {
                                        setFieldValue(`packageCount`, value);
                                    }}
                                    data-testid="packageCount"
                                />
                            </Form.Item>
                            <Form.Item
                                colon={false}
                                label={`${labels[objectionType].objectionDescription} :`}
                                labelAlign="left"
                                validateStatus={errors.text && touched.text ? "error" : "success"}
                                help={errors.text && touched.text ? errors.text : null}
                            >
                                <Input.TextArea
                                    cols={120}
                                    rows={4}
                                    name="text"
                                    value={values.text}
                                    onChange={handleChange}
                                    data-testid="text"
                                />
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            )}
        </Modal>
    );
};

export default ShiftScoreObjectionModal;
